module.exports = __webpack_public_path__ + "static/media/bloom30.7c825aaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blooming/bloom30.jpg
// module id = 646
// module chunks = 0